// projekt/frontend/src/App.js

import React, { useState, useEffect, useRef } from 'react';
import './Kalkulator.css';
import { FiCalendar, FiDollarSign, FiUserCheck, FiTool, FiMoon, FiSun } from 'react-icons/fi';

function App() {
  const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };
  // === Tema (dark/light) ===
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('theme') === 'dark';
    setDarkMode(saved);
    document.documentElement.setAttribute('data-theme', saved ? 'dark' : 'light');
  }, []);

  const toggleTheme = () => {
    const mode = !darkMode;
    setDarkMode(mode);
    document.documentElement.setAttribute('data-theme', mode ? 'dark' : 'light');
    localStorage.setItem('theme', mode ? 'dark' : 'light');
  };

    // === REŠENJE: Računanje prošlog mjeseca ===
  const danas = new Date();
  const trenutniMjesecIndex = danas.getMonth(); // Vraća 0-11
  const trenutnaGodina = danas.getFullYear();

  let inicijalniMjesec = '';
  let inicijalnaGodina = '';

  if (trenutniMjesecIndex === 0) {
    // Ako je sada Januar (0), prošli mjesec je Decembar (12) prošle godine
    inicijalniMjesec = 12;
    inicijalnaGodina = trenutnaGodina - 1;
  } else {
    // Inače, broj mjeseca jednak je indeksu (npr. Mart je indeks 2, prošli je Februar 2)
    inicijalniMjesec = trenutniMjesecIndex;
    inicijalnaGodina = trenutnaGodina;
  }
  
  // === STATE za polja forme ===
  const [mjesec, setMjesec] = useState(inicijalniMjesec.toString()); // OVDJE JE PROMJENA
  const [godina, setGodina] = useState(inicijalnaGodina.toString());   // OVDJE JE PROMJENA
  const [staz, setStaz] = useState('');

  // Reverzna kalkulacija
  const [unosTip, setUnosTip] = useState('brutoPlata');
  const [selectedPreset, setSelectedPreset] = useState('');
  const [brutoPlata, setBrutoPlata] = useState('1672.13');
  const [netoPlata, setNetoPlata] = useState('1100.00');
  const [solidarnostNeto, setSolidarnostNeto] = useState('');
  const [brutoUkupno, setBrutoUkupno] = useState('');

  // Ostala polja
  const [neplaceno, setNeplaceno] = useState('');
  const [neodradeniSati, setNeodradeniSati] = useState('');
  const [licniOdbitak, setLicniOdbitak] = useState('');
  const [umanjenje, setUmanjenje] = useState('');

  // Dodatni sati
  const [imaPreko, setImaPreko] = useState(false);
  const [prekovremeni, setPrekovremeni] = useState(false);
  const [prekovremeniSati, setPrekovremeniSati] = useState('');
  const [prekovremeniProc, setPrekovremeniProc] = useState('');

  const [nocni, setNocni] = useState(false);
  const [nocniSati, setNocniSati] = useState('');
  const [nocniProc, setNocniProc] = useState('');

  const [praznik, setPraznik] = useState(false);
  const [praznikSati, setPraznikSati] = useState('');
  const [praznikProc, setPraznikProc] = useState('');

  // === STATE za poruke gresaka ===
  const [errors, setErrors] = useState({
    mjesec: '',
    staz: '',
    brutoPlata: '',
    netoPlata: '',
    solidarnostNeto: '',
    brutoUkupno: '',
    neplaceno: '',
    neodradeniSati: '',
    licniOdbitak: '',
    umanjenje: '',
    prekovremeniSati: '',
    prekovremeniProc: '',
    nocniSati: '',
    nocniProc: '',
    praznikSati: '',
    praznikProc: '',
  });

  // === STATE za rezultate i loading/error ===
  const [rezultati, setRezultati_topli] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Ref za kontejner rezultata
  const resultsRef = useRef(null);

  // === Funkcija za validaciju polja ===
  const validateField = (fieldName, value) => {
    let msg = '';

    const relatedUnosTypes = {
      brutoPlata: ['brutoPlata', 'brutoPlataNK'],
      netoPlata: ['netoPlata', 'netoPlataNK'],
      solidarnostNeto: ['solidarnostNeto'],
      brutoUkupno: ['brutoUkupno']
    };

    if (relatedUnosTypes[fieldName] && !relatedUnosTypes[fieldName].includes(unosTip)) {
      setErrors(prev => ({ ...prev, [fieldName]: '' }));
      return;
    }
    
    switch (fieldName) {
      case 'mjesec':
        if (value.trim() === '') {
          msg = 'Unesite mjesec (1–12).';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 1 || num > 12) {
            msg = 'Mjesec mora biti broj između 1 i 12.';
          }
        }
        break;

      case 'staz':
        if (value.trim() !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Staž mora biti broj ≥ 0 ili ostavite prazno.';
          }
        }
        break;

      case 'brutoPlata':
        if (value.trim() === '') {
          msg = 'Upišite bruto osnovnu platu.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Bruto plata mora biti nenegativan broj.';
          }
        }
        break;

      case 'netoPlata':
        if (value.trim() === '') {
          msg = 'Upišite neto platu.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Neto plata mora biti nenegativan broj.';
          }
        }
        break;

      case 'solidarnostNeto':
        if (value.trim() === '') {
          msg = 'Upišite neto nakon solidarnog doprinosa.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Solidarnost neto mora biti nenegativan broj.';
          }
        }
        break;

      case 'brutoUkupno':
        if (value.trim() === '') {
          msg = 'Upišite ukupni bruto trošak.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Bruto ukupno mora biti nenegativan broj.';
          }
        }
        break;

      case 'neplaceno':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Neplaćeni dani moraju biti nenegativan broj.';
          }
        }
        break;

      case 'neodradeniSati':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Unesite broj neodrađenih sati ≥ 0.';
          }
        }
        break;

      case 'licniOdbitak':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Lični odbitak mora biti nenegativan broj.';
          }
        }
        break;

      case 'umanjenje':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Iznos umanjenja mora biti nenegativan broj.';
          }
        }
        break;

      case 'prekovremeniSati':
        if (prekovremeni && value.trim() === '') {
          msg = 'Upišite broj sati prekovremenog rada.';
        } else if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Prekovremeni sati moraju biti nenegativan broj.';
          }
        }
        break;

      case 'prekovremeniProc':
        if (prekovremeni && value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Procenat prekovremenog rada mora biti nenegativan.';
          }
        }
        break;

      case 'nocniSati':
        if (nocni && value.trim() === '') {
          msg = 'Upišite broj sati noćnog rada.';
        } else if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Noćni sati moraju biti nenegativan broj.';
          }
        }
        break;

      case 'nocniProc':
        if (nocni && value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Procenat noćnog rada mora biti nenegativan.';
          }
        }
        break;

      case 'praznikSati':
        if (praznik && value.trim() === '') {
          msg = 'Upišite broj sati rada za praznik.';
        } else if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Praznični sati moraju biti nenegativan broj.';
          }
        }
        break;

      case 'praznikProc':
        if (praznik && value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Procenat rada za praznik mora biti nenegativan.';
          }
        }
        break;

      default:
        break;
    }

    setErrors(prev => ({ ...prev, [fieldName]: msg }));
  };

  // === Provjera valjanosti forme ===
  const isFormValid = () => {
    if (
      errors.mjesec ||
      mjesec.trim() === '' 
    ) {
      return false;
    }

    // --- POPRAVKA: Mapiranje unosTip na odgovarajuću vrijednost ---
    let odabranVal;
    if (['brutoPlata', 'brutoPlataNK'].includes(unosTip)) {
      odabranVal = brutoPlata;
    } else if (['netoPlata', 'netoPlataNK'].includes(unosTip)) {
      odabranVal = netoPlata;
    } else if (unosTip === 'solidarnostNeto') {
      odabranVal = solidarnostNeto;
    } else if (unosTip === 'brutoUkupno') {
      odabranVal = brutoUkupno;
    }
    // ----------------------------------------------------------

    if (!odabranVal || odabranVal.trim() === '') return false;
    
    // Provjera da li ima greške na trenutno aktivnom polju
    let activeFieldError = '';
    if (['brutoPlata', 'brutoPlataNK'].includes(unosTip)) activeFieldError = errors.brutoPlata;
    else if (['netoPlata', 'netoPlataNK'].includes(unosTip)) activeFieldError = errors.netoPlata;
    else activeFieldError = errors[unosTip];

    if (activeFieldError) return false;

    for (let key of Object.keys(errors)) {
      if (errors[key]) return false;
    }
    return true;
  };

  // === useEffect za slanje podataka i dohvat rezultata ===
  useEffect(() => {
    validateField('mjesec', mjesec);
    validateField('staz', staz);

    validateField('brutoPlata', brutoPlata);
    validateField('netoPlata', netoPlata);
    validateField('solidarnostNeto', solidarnostNeto);
    validateField('brutoUkupno', brutoUkupno);

    validateField('neplaceno', neplaceno);
    validateField('neodradeniSati', neodradeniSati);
    validateField('licniOdbitak', licniOdbitak);
    validateField('umanjenje', umanjenje);
    validateField('prekovremeniSati', prekovremeniSati);
    validateField('prekovremeniProc', prekovremeniProc);
    validateField('nocniSati', nocniSati);
    validateField('nocniProc', nocniProc);
    validateField('praznikSati', praznikSati);
    validateField('praznikProc', praznikProc);

    if (!isFormValid()) {
      setRezultati_topli(null);
      return;
    }

    const payload = {
      mjesec: parseInt(mjesec.replace(',', '.'), 10),
      godina: 2026,
      staz: staz.trim() === '' ? 0 : parseInt(staz.replace(',', '.'), 10),

      neplaceno: neplaceno.trim() === '' ? null : parseFloat(neplaceno.replace(',', '.')),
      neodrađeni_sati:
        neodradeniSati.trim() === '' ? null : parseFloat(neodradeniSati.replace(',', '.')),
      licni_odbitak_input:
        licniOdbitak.trim() === '' ? null : parseFloat(licniOdbitak.replace(',', '.')),
      umanjenje: umanjenje.trim() === '' ? null : parseFloat(umanjenje.replace(',', '.')),

      ima_preko: imaPreko,
      prekovremeni: prekovremeni,
      prekovremeni_sati:
        prekovremeniSati.trim() === '' ? null : parseFloat(prekovremeniSati.replace(',', '.')),
      prekovremeni_proc:
        prekovremeniProc.trim() === '' ? null : parseFloat(prekovremeniProc.replace(',', '.')),

      nocni: nocni,
      nocni_sati: nocniSati.trim() === '' ? null : parseFloat(nocniSati.replace(',', '.')),
      nocni_proc:
        nocniProc.trim() === '' ? null : parseFloat(nocniProc.replace(',', '.')),

      praznik: praznik,
      praznik_sati: praznikSati.trim() === '' ? null : parseFloat(praznikSati.replace(',', '.')),
      praznik_proc:
        praznikProc.trim() === '' ? null : parseFloat(praznikProc.replace(',', '.')),

      bruto_plata_input:
        (unosTip === 'brutoPlata' || unosTip === 'brutoPlataNK') && brutoPlata.trim() !== ''
          ? (() => {
              const val = parseFloat(brutoPlata.replace(',', '.'));
              // Ako je NK tip, oduzimamo 50 prije slanja
              return unosTip === 'brutoPlataNK' ? val - 50 : val;
            })()
          : null,
      neto_plata_input:
        (unosTip === 'netoPlata' || unosTip === 'netoPlataNK') && netoPlata.trim() !== ''
          ? (() => {
              const val = parseFloat(netoPlata.replace(',', '.'));
              // Ako je NK tip, oduzimamo 50 prije slanja
              return unosTip === 'netoPlataNK' ? val - 50 : val;
            })()
          : null,
      solidarnost_neto_input:
        unosTip === 'solidarnostNeto' && solidarnostNeto.trim() !== ''
          ? parseFloat(solidarnostNeto.replace(',', '.'))
          : null,
      bruto_ukupno_input:
        unosTip === 'brutoUkupno' && brutoUkupno.trim() !== ''
          ? parseFloat(brutoUkupno.replace(',', '.'))
          : null,
    };

    setLoading(true);
    setSubmitError(null);

    fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/calculate_topli', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json();
          throw new Error(data.detail || 'Greška pri izračunu');
        }
        return res.json();
      })
      .then((data) => {
        setRezultati_topli(data);
        setLoading(false);
      })
      .catch((e) => {
        setSubmitError(e.message);
        setRezultati_topli(null);
        setLoading(false);
      });
  }, [
    mjesec,
    staz,
    unosTip,
    brutoPlata,
    netoPlata,
    solidarnostNeto,
    brutoUkupno,
    neplaceno,
    neodradeniSati,
    licniOdbitak,
    umanjenje,
    imaPreko,
    prekovremeni,
    prekovremeniSati,
    prekovremeniProc,
    nocni,
    nocniSati,
    nocniProc,
    praznik,
    praznikSati,
    praznikProc,
  ]);

  // === Pomoćne funkcije za prikaz ===
  const formatirajDatum = () => {
    const mm = mjesec.toString().padStart(2, '0');
    const gg = "2026";
    return `${mm}.${gg}.`;
  };

  const prikaziDane = (polje) => {
    return polje === '' ? 0 : parseInt(polje, 10);
  };

  const prikaziStaz = (polje) => {
    return polje === '' ? 0 : parseInt(polje, 10);
  };
        

  // === Funkcija za resetiranje polja ===
  const clearAll = () => {
    setMjesec('');
    setStaz('');
    setUnosTip('brutoPlata');
    setBrutoPlata('');
    setNetoPlata('');
    setSolidarnostNeto('');
    setBrutoUkupno('');
    setNeplaceno('');
    setNeodradeniSati('');
    setLicniOdbitak('');
    setUmanjenje('');
    setImaPreko(false);
    setPrekovremeni(false);
    setPrekovremeniSati('');
    setPrekovremeniProc('');
    setNocni(false);
    setNocniSati('');
    setNocniProc('');
    setPraznik(false);
    setPraznikSati('');
    setPraznikProc('');
    setErrors({
      mjesec: '',
      staz: '',
      brutoPlata: '',
      netoPlata: '',
      solidarnostNeto: '',
      brutoUkupno: '',
      neplaceno: '',
      neodradeniSati: '',
      licniOdbitak: '',
      umanjenje: '',
      prekovremeniSati: '',
      prekovremeniProc: '',
      nocniSati: '',
      nocniProc: '',
      praznikSati: '',
      praznikProc: '',
    });
    setRezultati_topli(null);
    setSubmitError(null);
  };

    const handlePresetChange = (e) => {
    const preset = e.target.value;
    setSelectedPreset(preset);

    let newBruto = '';
    let newNeto = '';

    // Vrijednosti prema tvom zaglavlju za 2026.
    if (preset === 'nk_pk') {
      newBruto = '1476.23';
      newNeto = '1000.00';
    } else if (preset === 'kv') {
      newBruto = '1558.20';
      newNeto = '1050.00';
    } else if (preset === 'sss') {
      newBruto = '1672.13';
      newNeto = '1100.00';
    } else if (preset === 'vss') {
      newBruto = '2081.97';
      newNeto = '1350.00';
    } else if (preset === 'mr_dr') {
      newBruto = '2245.90';
      newNeto = '1450.00';
    }

    // Ako je odabran neki preset, ažuriraj odgovarajuće polje
    if (preset) {
      if (['brutoPlata', 'brutoPlataNK'].includes(unosTip)) {
        setBrutoPlata(newBruto);
        setNetoPlata(''); // Očistimo suprotno polje
      } else if (['netoPlata', 'netoPlataNK'].includes(unosTip)) {
        setNetoPlata(newNeto);
        setBrutoPlata(''); // Očistimo suprotno polje
      }
    }
  };

  // ======================= POČETAK TVOG NOVOG KODA =======================

  // Ovo će nam reći da li trebamo prikazati "uvećane" iznose
  const isNK = ['brutoPlataNK', 'netoPlataNK'].includes(unosTip);

  // Pomoćne varijable za prikaz.
  // Koristimo "rezultati?. || 0" kako aplikacija ne bi "pukla" (crnila se) dok još nema rezultata.
  const prikazNeto = isNK ? (rezultati?.neto_plata || 0) + 50 : (rezultati?.neto_plata || 0);
  const prikazSolidarnost = isNK ? (rezultati?.solidarnost_neto || 0) + 50 : (rezultati?.solidarnost_neto || 0);
  const prikazBrutoOsnovna = isNK ? (rezultati?.bruto_plata_osnovna || 0) + 50 : (rezultati?.bruto_plata_osnovna || 0);
  const prikazBrutoUkupno = isNK ? (rezultati?.bruto_ukupno || 0) + 50 : (rezultati?.bruto_ukupno || 0);

  return (
    <>
      {/* Naslov aplikacije */}
      <header className="app-header">
        <h3>
          <b>Kalkulator plata u Republici Srpskoj (RS) – Obračun plate za 2026. godinu</b>
          <br />
          <br />
          <br />
        </h3>
              <h2>Ovaj kalkulator plata omogućava tačan obračun bruto i neto plate u Republici Srpskoj za 2026. godinu, 
    u skladu sa važećim zakonima i doprinosima. 
    <br />
    Alat je namijenjen zaposlenima, poslodavcima i računovođama za brz izračun primanja i ukupnog troška poslodavca.</h2>
        </header>
      <header className="app-header">
        <h3>
          <b>Najniži iznosi plata u 2026. godini, prema zahtijevanom stepenu stručnog zvanja, su:</b>
          <br />
          <br />
        </h3>
        <h2>
          <b>Nekvalifikovani / polukvalifikovani radnik (NK/PK):</b>
          <br />
          Bruto osnovna: 1476.23 / neto plata: 1000.00
          <br />
          <br />
          <b>Kvalifikovani radnik / SSS 3 godine (KV):</b>
          <br />
          Bruto osnovna: 1558.20 / neto plata: 1050.00
          <br />
          <br />
          <b>Srednja stručna sprema / visokokvalifikovani radnik (SSS/VKV):</b>
          <br />
          Bruto osnovna: 1672.13 / neto plata: 1100.00
          <br />
          <br />
          <b>Viša školska sprema (VŠS):</b>
          <br />
          Bruto osnovna: 2081.97 / neto plata: 1350.00
          <br />
          <br />
          <b>Visoka stručna sprema / magistar / doktor nauka (VSS/MR/DR):</b>
          <br />
          Bruto osnovna: 2245.90 / neto plata: 1450.00
          <br />
          <br />
          <br />
          <br />
          NK/PK i trogodišnja SSS imaju neoporezivi dio plate od 50 KM, a pravo na dodatak od 50 KM nije ograničen iznosom plate.
          <br />
        </h2>
    </header>
    
      <div className="container">
        {/* ==== LEVI STUPAC: FORMA ==== */}
        <div className="form-container card">
          {/* FORM HEADER */}
          <div className="form-header">
            <h2 className="section-title">Unos podataka</h2>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" className="clear-button" onClick={clearAll}>
                Obriši sve
              </button>
            <button type="button" className="clear-button" onClick={handlePrint}>Štampaj</button>
            </div>
          </div>

          {/* Sve polja u jednoj koloni */}
          <div className="field-group">
            <label htmlFor="unosTip" className="field-label">
              Odaberite osnov za kalkulaciju / stručnu spremu:<span className="required">*</span>
            </label>
            <select
              id="unosTip"
              className="field-select"
              value={unosTip}
              onChange={(e) => {
                const noviTip = e.target.value;
                setUnosTip(noviTip);

                // Čistimo greške
                setErrors(prev => ({
                  ...prev,
                  brutoPlata: '',
                  netoPlata: '',
                  solidarnostNeto: '',
                  brutoUkupno: '',
                }));

                
                // === AUTOMATSKO UPISIVANJE IZNOSA ===
                if (noviTip === 'brutoPlataNK') {
                  // Minimalna bruto osnovna za NK/PK/KV
                  setBrutoPlata('1476.23');
                  setNetoPlata('');
                  setSolidarnostNeto('');
                  setBrutoUkupno('');
                } else if (noviTip === 'netoPlataNK') {
                  // Minimalna neto za NK/PK/KV (1050 jer sistem oduzima 50)
                  setNetoPlata('1000.00');
                  setBrutoPlata('');
                  setSolidarnostNeto('');
                  setBrutoUkupno('');
                } else if (noviTip === 'brutoPlata' || noviTip === 'netoPlata' || noviTip === 'solidarnostNeto' || noviTip === 'brutoUkupno') {
                  // Za standardne opcije, čistimo sva polja
                  setBrutoPlata('1672.13');
                  setNetoPlata('1100.00');
                  setSolidarnostNeto('');
                  setBrutoUkupno('');
                }
              }}
            >
              <option value="brutoPlata">Bruto osnovna plata (SSS/VKV/VŠS/VSS/MR/DR)</option>
              <option value="brutoPlataNK">Bruto osnovna (NK/PK/KV)</option>
              <option value="netoPlata">Neto plata (SSS/VKV/VŠS/VSS/MR/DR)</option>
              <option value="netoPlataNK">Neto plata (NK/PK/KV)</option>
              <option value="solidarnostNeto">Neto posle solidarnog doprinosa</option>
              <option value="brutoUkupno">Ukupni bruto trošak (poslodavca)</option>
            </select>
          </div>

            {(unosTip === 'brutoPlata' || unosTip === 'brutoPlataNK') && (
            <div className="field-group">
              <label htmlFor="brutoPlata" className="field-label">
                {unosTip === 'brutoPlataNK' ? 'Bruto osnovna NK/PK/KV' : 'Bruto osnovna plata'}
                <span className="required">*</span>:
              </label>
              <input
                type="text"
                id="brutoPlata"
                className={`field-input ${errors.brutoPlata ? 'shake' : ''}`}
                placeholder={unosTip === 'brutoPlataNK' ? "npr. 1476.23" : "npr. 1672.13"}
                value={brutoPlata}
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.');
                  setBrutoPlata(v);
                  validateField('brutoPlata', v);
                }}
                onBlur={(e) => validateField('brutoPlata', e.target.value.replace(',', '.'))}
              />
              {errors.brutoPlata && <div className="error-text">{errors.brutoPlata}</div>}
            </div>
          )}

          {(unosTip === 'netoPlata' || unosTip === 'netoPlataNK') && (
            <div className="field-group">
              <label htmlFor="netoPlata" className="field-label">
                {unosTip === 'netoPlataNK' ? 'Neto plata NK/PK/KV' : 'Neto plata'}
                <span className="required">*</span>:
              </label>
              <input
                type="text"
                id="netoPlata"
                className={`field-input ${errors.netoPlata ? 'shake' : ''}`}
                placeholder={unosTip === 'netoPlataNK' ? "npr. 1000.00" : "npr. 1100.00"}
                value={netoPlata}
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.');
                  setNetoPlata(v);
                  validateField('netoPlata', v);
                }}
                onBlur={(e) => validateField('netoPlata', e.target.value.replace(',', '.'))}
              />
              {errors.netoPlata && <div className="error-text">{errors.netoPlata}</div>}
            </div>
          )}

          {unosTip === 'solidarnostNeto' && (
            <div className="field-group">
              <label htmlFor="solidarnostNeto" className="field-label">
                Neto plata sa odbijenim doprinosom na solidarnost<span className="required">*</span>
                <span className="tooltip-icon" title="Iznos nakon odbitka solidarnog doprinosa (5%)">ⓘ</span>
              </label>
              <input
                type="text"
                id="solidarnostNeto"
                className={`field-input ${errors.solidarnostNeto ? 'shake' : ''}`}
                placeholder="npr. 1400,00"
                value={solidarnostNeto}
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.');
                  setSolidarnostNeto(v);
                  validateField('solidarnostNeto', v);
                }}
                onBlur={(e) => validateField('solidarnostNeto', e.target.value.replace(',', '.'))}
              />
              {errors.solidarnostNeto && <div className="error-text">{errors.solidarnostNeto}</div>}
            </div>
          )}

          {unosTip === 'brutoUkupno' && (
            <div className="field-group">
              <label htmlFor="brutoUkupno" className="field-label">
                Ukupni bruto trošak poslodavca<span className="required">*</span>:
              </label>
              <input
                type="text"
                id="brutoUkupno"
                className={`field-input ${errors.brutoUkupno ? 'shake' : ''}`}
                placeholder="npr. 2800,00"
                value={brutoUkupno}
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.');
                  setBrutoUkupno(v);
                  validateField('brutoUkupno', v);
                }}
                onBlur={(e) => validateField('brutoUkupno', e.target.value.replace(',', '.'))}
              />
              {errors.brutoUkupno && <div className="error-text">{errors.brutoUkupno}</div>}
            </div>
          )}

                    {/* === NOVI DRODOWN FOR PRESETS (Sa uslovnim prikazom) === */}
          {['brutoPlata', 'brutoPlataNK', 'netoPlata', 'netoPlataNK'].includes(unosTip) && (
            <div className="field-group">
              <label htmlFor="presetSelect" className="field-label">
                Brzo biranje iznosa (Minimalne plate 2026):
              </label>
              <select
                id="presetSelect"
                className="field-select"
                value={selectedPreset}
                onChange={handlePresetChange}
              >
                <option value="">-- Odaberite preddefinisanu platu --</option>

                {/* === GRUPA 1: Prikazuje se SAMO ako je odabran tip NK/PK/KV === */}
                {(unosTip === 'brutoPlataNK' || unosTip === 'netoPlataNK') && (
                  <>
                    <option value="nk_pk">NK/PK (Bruto 1476.23 / Neto 1000.00)</option>
                    <option value="kv">KV (Bruto 1558.20 / Neto 1050.00)</option>
                  </>
                )}

                {/* === GRUPA 2: Prikazuje se SAMO ako je odabran standardni tip (Bruto/Neto) === */}
                {(unosTip === 'brutoPlata' || unosTip === 'netoPlata') && (
                  <>
                    <option value="sss">SSS/VKV (Bruto 1672.13 / Neto 1100.00)</option>
                    <option value="vss">VŠS (Bruto 2081.97 / Neto 1350.00)</option>
                    <option value="mr_dr">VSS/MR/DR (Bruto 2245.90 / Neto 1450.00)</option>
                  </>
                )}
              </select>
            </div>
          )}

          <div className="field-group">
            <label htmlFor="mjesec" className="field-label">
              Mjesec<span className="required">*</span> (1–12):
            </label>
            <input
              type="text"
              id="mjesec"
              className={`field-input ${errors.mjesec ? 'shake' : ''}`}
              placeholder="npr. 7"
              value={mjesec}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setMjesec(v);
                validateField('mjesec', v);
              }}
              onBlur={(e) => validateField('mjesec', e.target.value.replace(',', '.'))}
            />
            {errors.mjesec && <div className="error-text">{errors.mjesec}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="staz" className="field-label">
              Radni staž (godine):
            </label>
            <input
              type="text"
              id="staz"
              className={`field-input ${errors.staz ? 'shake' : ''}`}
              placeholder="npr. 5"
              value={staz}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setStaz(v);
                validateField('staz', v);
              }}
              onBlur={(e) => validateField('staz', e.target.value.replace(',', '.'))}
            />
            {errors.staz && <div className="error-text">{errors.staz}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="neplaceno" className="field-label">
              NEPLAĆENO odsustno: <br />(ili neodrađeni radni dani zbog kasnijeg stupanja u radni odnos (broj dana))
            </label>
            <input
              type="text"
              id="neplaceno"
              className={`field-input ${errors.neplaceno ? 'shake' : ''}`}
              placeholder="npr. 2"
              value={neplaceno}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setNeplaceno(v);
                validateField('neplaceno', v);
              }}
              onBlur={(e) => validateField('neplaceno', e.target.value.replace(',', '.'))}
            />
            {errors.neplaceno && <div className="error-text">{errors.neplaceno}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="neodradeniSati" className="field-label">
              Neodrađeni radni sati u mjesecu:<br /> (npr. zbog kašnjenja, ranijeg izlaska)
            </label>
            <input
              type="text"
              id="neodradeniSati"
              className={`field-input ${errors.neodradeniSati ? 'shake' : ''}`}
              placeholder="npr. 8"
              value={neodradeniSati}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setNeodradeniSati(v);
                validateField('neodradeniSati', v);
              }}
              onBlur={(e) => validateField('neodradeniSati', e.target.value.replace(',', '.'))}
            />
            {errors.neodradeniSati && <div className="error-text">{errors.neodradeniSati}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="licniOdbitak" className="field-label">
              Lični odbitak (ostavite prazno za 1000 KM):
            </label>
            <input
              type="text"
              id="licniOdbitak"
              className={`field-input ${errors.licniOdbitak ? 'shake' : ''}`}
              placeholder="npr. 1000,00"
              value={licniOdbitak}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setLicniOdbitak(v);
                validateField('licniOdbitak', v);
              }}
              onBlur={(e) => validateField('licniOdbitak', e.target.value.replace(',', '.'))}
            />
            {errors.licniOdbitak && <div className="error-text">{errors.licniOdbitak}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="umanjenje" className="field-label">
              Umanjenje poreza (ostavite prazno za 0):
            </label>
            <input
              type="text"
              id="umanjenje"
              className={`field-input ${errors.umanjenje ? 'shake' : ''}`}
              placeholder="npr. 50,00"
              value={umanjenje}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setUmanjenje(v);
                validateField('umanjenje', v);
              }}
              onBlur={(e) => validateField('umanjenje', e.target.value.replace(',', '.'))}
            />
            {errors.umanjenje && <div className="error-text">{errors.umanjenje}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="imaPreko" className="field-label">
              Dodatni sati (prekovremeni, noćni, praznik)?
            </label>
            <select
              id="imaPreko"
              className="field-select"
              value={imaPreko ? 'da' : 'ne'}
              onChange={(e) => setImaPreko(e.target.value === 'da')}
            >
              <option value="ne">Ne</option>
              <option value="da">Da</option>
            </select>
          </div>

          {imaPreko && (
            <>
              {/* Prekovremeni rad */}
              <div className="field-group">
                <label htmlFor="prekovremeni" className="field-label">
                  Prekovremeni rad (da/ne):
                </label>
                <select
                  id="prekovremeni"
                  className="field-select"
                  value={prekovremeni ? 'da' : 'ne'}
                  onChange={(e) => {
                    const val = e.target.value === 'da';
                    setPrekovremeni(val);
                    if (!val) {
                      setErrors(prev => ({
                        ...prev,
                        prekovremeniSati: '',
                        prekovremeniProc: '',
                      }));
                      setPrekovremeniSati('');
                      setPrekovremeniProc('');
                    }
                  }}
                >
                  <option value="ne">Ne</option>
                  <option value="da">Da</option>
                </select>
              </div>
              {prekovremeni && (
                <>
                  <div className="field-group">
                    <label htmlFor="prekovremeniSati" className="field-label">
                      Broj sati prekovremenog rada<span className="required">*</span>:
                    </label>
                    <input
                      type="text"
                      id="prekovremeniSati"
                      className={`field-input ${errors.prekovremeniSati ? 'shake' : ''}`}
                      placeholder="npr. 10"
                      value={prekovremeniSati}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPrekovremeniSati(v);
                        validateField('prekovremeniSati', v);
                      }}
                      onBlur={(e) =>
                        validateField('prekovremeniSati', e.target.value.replace(',', '.'))
                      }
                    />
                    {errors.prekovremeniSati && (
                      <div className="error-text">{errors.prekovremeniSati}</div>
                    )}
                  </div>
                  <div className="field-group">
                    <label htmlFor="prekovremeniProc" className="field-label">
                      Procenat uvećanja (ostavite prazno za 26%):
                    </label>
                    <input
                      type="text"
                      id="prekovremeniProc"
                      className={`field-input ${errors.prekovremeniProc ? 'shake' : ''}`}
                      placeholder="npr. 26"
                      value={prekovremeniProc}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPrekovremeniProc(v);
                        validateField('prekovremeniProc', v);
                      }}
                      onBlur={(e) =>
                        validateField('prekovremeniProc', e.target.value.replace(',', '.'))
                      }
                    />
                    {errors.prekovremeniProc && (
                      <div className="error-text">{errors.prekovremeniProc}</div>
                    )}
                  </div>
                </>
              )}

              {/* Noćni rad */}
              <div className="field-group">
                <label htmlFor="nocni" className="field-label">
                  Noćni rad (da/ne):
                </label>
                <select
                  id="nocni"
                  className="field-select"
                  value={nocni ? 'da' : 'ne'}
                  onChange={(e) => {
                    const val = e.target.value === 'da';
                    setNocni(val);
                    if (!val) {
                      setErrors(prev => ({ ...prev, nocniSati: '', nocniProc: '' }));
                      setNocniSati('');
                      setNocniProc('');
                    }
                  }}
                >
                  <option value="ne">Ne</option>
                  <option value="da">Da</option>
                </select>
              </div>
              {nocni && (
                <>
                  <div className="field-group">
                    <label htmlFor="nocniSati" className="field-label">
                      Broj sati noćnog rada<span className="required">*</span>:
                    </label>
                    <input
                      type="text"
                      id="nocniSati"
                      className={`field-input ${errors.nocniSati ? 'shake' : ''}`}
                      placeholder="npr. 8"
                      value={nocniSati}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setNocniSati(v);
                        validateField('nocniSati', v);
                      }}
                      onBlur={(e) => validateField('nocniSati', e.target.value.replace(',', '.'))}
                    />
                    {errors.nocniSati && <div className="error-text">{errors.nocniSati}</div>}
                  </div>
                  <div className="field-group">
                    <label htmlFor="nocniProc" className="field-label">
                      Procenat uvećanja (ostavite prazno za 26%):
                    </label>
                    <input
                      type="text"
                      id="nocniProc"
                      className={`field-input ${errors.nocniProc ? 'shake' : ''}`}
                      placeholder="npr. 26"
                      value={nocniProc}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setNocniProc(v);
                        validateField('nocniProc', v);
                      }}
                      onBlur={(e) => validateField('nocniProc', e.target.value.replace(',', '.'))}
                    />
                    {errors.nocniProc && <div className="error-text">{errors.nocniProc}</div>}
                  </div>
                </>
              )}

              {/* Praznični rad */}
              <div className="field-group">
                <label htmlFor="praznik" className="field-label">
                  Rad za praznik (da/ne):
                </label>
                <select
                  id="praznik"
                  className="field-select"
                  value={praznik ? 'da' : 'ne'}
                  onChange={(e) => {
                    const val = e.target.value === 'da';
                    setPraznik(val);
                    if (!val) {
                      setErrors(prev => ({ ...prev, praznikSati: '', praznikProc: '' }));
                      setPraznikSati('');
                      setPraznikProc('');
                    }
                  }}
                >
                  <option value="ne">Ne</option>
                  <option value="da">Da</option>
                </select>
              </div>
              {praznik && (
                <>
                  <div className="field-group">
                    <label htmlFor="praznikSati" className="field-label">
                      Broj sati odrađenih za vrijeme praznika<span className="required">*</span>:
                    </label>
                    <input
                      type="text"
                      id="praznikSati"
                      className={`field-input ${errors.praznikSati ? 'shake' : ''}`}
                      placeholder="npr. 8"
                      value={praznikSati}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPraznikSati(v);
                        validateField('praznikSati', v);
                      }}
                      onBlur={(e) => validateField('praznikSati', e.target.value.replace(',', '.'))}
                    />
                    {errors.praznikSati && <div className="error-text">{errors.praznikSati}</div>}
                  </div>
                  <div className="field-group">
                    <label htmlFor="praznikProc" className="field-label">
                      Procenat uvećanja (ostavite prazno za 210%):
                    </label>
                    <input
                      type="text"
                      id="praznikProc"
                      className={`field-input ${errors.praznikProc ? 'shake' : ''}`}
                      placeholder="npr. 210"
                      value={praznikProc}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPraznikProc(v);
                        validateField('praznikProc', v);
                      }}
                      onBlur={(e) => validateField('praznikProc', e.target.value.replace(',', '.'))}
                    />
                    {errors.praznikProc && <div className="error-text">{errors.praznikProc}</div>}
                  </div>
                </>
              )}
            </>
          )}
        </div>


 
          <div ref={printRef} className="print-area">
        {/* ==== DESNI STUPAC: REZULTATI ==== */}
        <div className="results-container card" ref={resultsRef}>
          <h2 className="section-title">Rezultati obračuna</h2>

          {loading && (
            <div className="loader" style={{ display: 'flex', alignItems: 'center' }}>
              <span className="spinner"></span>
              <span>Računam…</span>
            </div>
          )}
          {submitError && <div className="error-text loader">{submitError}</div>}

          {rezultati && !loading && (
            <>
            
              {/* ======== SEKCIJA 1: OSNOVNI PREGLED ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiCalendar style={{ marginRight: '8px' }} />
                  Podaci o mjesecu i stažu
                </h3>
                <div className="result-row">
                  <span>Radni dani u {formatirajDatum()}</span>
                  <span>{rezultati.radni_dani} dana</span>
                </div>
                <div className="result-row">
                  <span>Plaćeni dani (radnik na poslu)</span>
                  <span>{rezultati.dana_radio} dana</span>
                </div>
                <div className="result-row">
                  <span>Radni sati u {formatirajDatum()}</span>
                  <span>{rezultati.mjesec_sati} sati</span>
                </div>
                <div className="result-row">
                  <span>Staž (godine)</span>
                  <span>{prikaziStaz(staz)} godina</span>
                </div>
              </div>

              {/* ======== SEKCIJA 7: DOPRINOSI ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiDollarSign style={{ marginRight: '8px' }} />
                  Doprinosi
                </h3>
                <div className="result-row">
                  <span>PIO</span>
                  <span>{rezultati.PIO.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Zdravstveno</span>
                  <span>{rezultati.zdravstveno.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Nezaposlenost</span>
                  <span>{rezultati.nezaposlenost.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Za djecu</span>
                  <span>{rezultati.djeca.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Doprinosi ukupno</b></span>
                  <span><b>{rezultati.doprinosi_ukupno.toFixed(2)} KM</b></span>
                </div>
              </div>

              {/* ======== SEKCIJA 3: POREZ ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiDollarSign style={{ marginRight: '8px' }} />
                  Porez
                </h3>
                <div className="result-row">
                  <span>Iznos poreza</span>
                  <span>{rezultati.porez.toFixed(2)} KM</span>
                </div>
              </div>

              {/* ======== SEKCIJA 4: NETO PLATA ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiTool style={{ marginRight: '8px' }} />
                  Neto plata {isNK ? '(NK/PK/KV)' : ''}
                </h3>
                <div className="result-row">
                  <span><b>Neto plata</b></span>
                  <span><b>{prikazNeto.toFixed(2)} KM</b></span>
                </div>
                <div className="result-row">
                  <span>Doprinos za solidarnost</span>
                  {/* Solidarnost se računa na osnovu neto plate, pa ako je neto uvećano, prikazujemo uvećano */}
                  <span>{(isNK ? rezultati.solidarnost_iznos : rezultati.solidarnost_iznos).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Neto nakon odbitka doprinosa na solidarnost</b></span>
                  <span><b>{prikazSolidarnost.toFixed(2)} KM</b></span>
                </div>
              </div>


              {/* ======== SEKCIJA 5: BRUTO & MINULI RAD ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiUserCheck style={{ marginRight: '8px' }} />
                  Bruto i minuli rad {isNK ? '(NK/PK/KV)' : ''}
                </h3>
                <div className="result-row">
                  <span>Bruto osnovna plata</span>
                  <span>{prikazBrutoOsnovna.toFixed(2)} KM</span>
                </div>
                {/* Ostatak sekcije ostaje isti... */}
                <div className="result-row">
                    <span>Bruto osnovna plata s uvećanjima</span>
                    {/* Ovo verovatno treba da uvećamo samo ako je osnovna NK? 
                        Za sada ćemo ostaviti ovako osim ako nije specifično definisano. */}
                    <span>{rezultati.bruto_plata_sa_uvecanjem.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Minuli rad</span>
                  <span>{rezultati.minuli_rad.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Ukupni troškovi bruto plate</b></span>
                  <span><b>{prikazBrutoUkupno.toFixed(2)} KM</b></span>
                </div>  
                <div className="result-row">
                  <span>Bruto bez zdravstva (radnik iz FBIH/Brcko Distrikta)</span>
                  <span>{(rezultati.bruto_ukupno - rezultati.zdravstveno).toFixed(2)} KM</span>
                </div>
              </div>    

              {/* ======== SEKCIJA 6: ODSUSTVA & NEODRAĐENI SATI ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiCalendar style={{ marginRight: '8px' }} />
                  Odsustva i neodrađeni sati
                </h3>
                <div className="result-row">
                  <span>Neplaćeni dani</span>
                  <span>{prikaziDane(neplaceno)} dana</span>
                </div>
                <div className="result-row">
                  <span>Neodrađeni sati</span>
                  <span>{rezultati.neradno_vrijeme} sati</span>
                </div>
              </div>

              {/* ======== SEKCIJA 8: DODACI (prekovremeni, noćni, praznik) ======== */}
              {imaPreko && (
                <div className="results-section">
                  <h3 className="subsection-title">
                    <FiTool style={{ marginRight: '8px' }} />
                    Dodaci (prekovremeni, noćni, praznik)
                  </h3>
                  {prekovremeni && (
                    <div className="result-row">
                      <span>Prekovremeni sati</span>
                      <span>{rezultati.prekovremeni_sati} sati</span>
                    </div>
                  )}
                  {nocni && (
                    <div className="result-row">
                      <span>Noćni sati</span>
                      <span>{rezultati.nocni_sati} sati</span>
                    </div>
                  )}
                  {praznik && (
                    <div className="result-row">
                      <span>Praznični sati</span>
                      <span>{rezultati.praznik_sati} sati</span>
                    </div>
                  )}
                  <div className="result-row">
                    <span>Ukupno povećanje bruto osnovne plate</span>
                    <span>{rezultati.ukupno_uvecanje.toFixed(2)} KM</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      </div>
    </>
  );
}

export default App;
